import { useUrlGenerator } from '@folklore/routes';
import { useParams } from 'wouter';

import { useBrand, useDefaultBrand, useSite, useSubscriptions } from '../../contexts/SiteContext';
import Metadata, { MetadataProps } from './Metadata';

export interface SubscribeMetadataProps extends MetadataProps {
    friend?: boolean;
}

function SubscribeMetadata({ friend = false, ...props }: SubscribeMetadataProps) {
    const { brand: brandParam = null } = useParams<{ brand?: string }>();
    const defaultBrand = useDefaultBrand();
    const brand = useBrand(brandParam);
    const finalBrand = brandParam !== null ? brand : defaultBrand;
    const { label: brandLabel, handle: brandHandle } = finalBrand || {};
    const subscriptions = useSubscriptions();
    const { description } = subscriptions.find(({ handle }) => handle === brandHandle) || {};
    const url = useUrlGenerator();
    return (
        <Metadata
            brand={finalBrand}
            title={
                brandHandle === 'france'
                    ? 'La newsletter URBANIA - Abonnez-vous!'
                    : friend
                      ? `Abonnez quelqu’un à ${brandLabel}`
                      : `Abonnez-vous à ${brandLabel}`
            }
            withoutTitleSuffix
            description={description}
            url={url('subscribe', {
                brand: brandParam,
            })}
            pageType="subscribe"
            {...props}
        />
    );
}

export default SubscribeMetadata;
